import cls from 'clsx';
import React from 'react';
import styles from './MessageBar.module.scss';

interface Props {
  className?: string;
  children: React.ReactNode;
  type?: 'info' | 'warning';
}

export const MessageBar = ({
  className,
  children,
  type = 'info',
  ...rest
}: Props) => (
  <div className={cls(styles.container, styles[type], className)} {...rest}>
    {children}
  </div>
);
